export default __webpack_public_path__ + "static/media/polaroid33.15370e7f.jpg";